import { tabs as types } from '../actions/actiontypes'

interface TabUpdate {
  place: string
  currentIndex: number
}

interface TabsState {
  tabs: { [key: string]: number }
}

interface TabAction {
  type: string
  tab?: TabUpdate
}

const initState: TabsState = {
  tabs: {},
}

const updateTab = (update: TabUpdate, state: TabsState): { [key: string]: number } => {
  const updatedTabs = {
    ...state.tabs,
    [update.place]: update.currentIndex
  }
  return updatedTabs
}

export function tabsReducer(state: TabsState = initState, action: TabAction): TabsState {
  switch (action.type) {
    case 'STORE_RESET':
      return {
        ...initState,
      }
    case types.UPDATE:
      return {
        ...state,
        tabs: updateTab(action.tab!, state),
      }
    default:
      return state
  }
}